import gql from 'graphql-tag'

export default gql`mutation updateProjectClientInvoices($data: ProjectClientInvoiceInput) {
    updateProjectClientInvoices(data: $data) @client
}`